import React, {useState} from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import styles from './LayoutPage.module.scss'
import Header from '../../components/common/layout/Header';
import Sider from '../../components/common/layout/Sider';
import Content from '../../components/common/layout/Content';

const LayoutPage: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <Layout className={styles.layout}>
      <Header onClick={() => setCollapsed(!collapsed)} />
      <Layout className={styles.content_layout}>
        <Sider collapsed={collapsed} onCollapse={() => setCollapsed(!collapsed)} />
        <Content>
          <Outlet />
        </Content>
      </Layout>
      {/*<Footer/>*/}
    </Layout>
  );
};

export default LayoutPage;
